import { proxy } from 'valtio';
import { ParamsStore } from '@context/params';
import type { ExploreTypeChoice, SearchPageStoreState } from './schema';
import { SEARCH_TAB_CHOICES } from './schema';

export const searchPageStoreState = proxy<SearchPageStoreState>({
  activeTab: SEARCH_TAB_CHOICES.SOUNDS,
  exploreType: ParamsStore.explore_type as ExploreTypeChoice,
});
